module.exports = __webpack_public_path__ + "img/03-title-03-mobile.22701bc8.png";